'use client'
 
import type { Partner } from '@/payload-types'
import { createContext, useState } from 'react'

type Props = {
    clientSidePartner: Partner
    setClientSidePartner: (value: Partner) => void
}
 
export const ClientSidePartnerContext = createContext<Props>({} as Props)

export default function ClientSidePartnerProvider({
    partner,
    children,
}: {
    partner: Partner,
    children: React.ReactNode
}) {

    const [clientSidePartner, setClientSidePartner] = useState(partner)

    return <ClientSidePartnerContext.Provider value={{clientSidePartner, setClientSidePartner}}>{children}</ClientSidePartnerContext.Provider>
}
